module.exports = __webpack_public_path__ + "static/4eeaef8c88061f0cbd4c2f4e16658f8fd07a0407b952d763c437092b0fdb7660-8312b3924793126941233812daf16c0d.png";